import { mapToOptions } from '../utils/mapToOptions';
import { COUNTRY_CODES_MAP } from '../utils/countries';

export const countrySelectOptions = mapToOptions(COUNTRY_CODES_MAP, 'value');
